import { createContext, useContext, useState } from "react";
type OnboardingContextType = {
  isOnboardingLoading: boolean;
  enableOnboardingLoading: () => void;
  disableOnboardingLoading: () => void;
  setLoading: (loading: boolean) => void;
};

const OnbaordingContext = createContext<OnboardingContextType | null>(null);

export const OnboardingProvider = ({ children }: { children: React.ReactNode }) => {
  const [isOnboardingLoading, setOnboardingLoading] = useState(false);

  const enableOnboardingLoading = () => {
    setOnboardingLoading(true);
  };

  const disableOnboardingLoading = () => {
    setOnboardingLoading(false);
  };

  // @TODO: remove this function
  const setLoading = (loading: boolean) => {
    setOnboardingLoading(loading);
  };

  return (
    <OnbaordingContext.Provider
      value={{
        isOnboardingLoading,
        enableOnboardingLoading,
        disableOnboardingLoading,
        setLoading,
      }}
    >
      {children}
    </OnbaordingContext.Provider>
  );
};
export const useOnboardingContext = () => {
  const context = useContext(OnbaordingContext);
  if (!context) {
    throw new Error("Error from OnboardingProvider context api");
  }
  return context;
};
